<template>

  <div class="head">

    <div id="pc">

      <img src="@/img/pc/Slice 10@2x.png" alt="">
      <div>
        <img src="@/img/pc/bg@2x.png" alt="">
        <img src="@/img/pc/qr.png" alt="">
      </div>
      <p>海鸥聊天 全方位守护你的隐私安全 已超 <span style="color: #4371FF;font-size: 25px;">5000000+</span> 用户正在使用</p>
      <div>
        <div><img src="@/img/pc/Frame@2x(15).png" alt=""><span>应用锁保护</span></div>
        <div><img src="@/img/pc/Frame@2x(14).png" alt=""><span>高清通话</span></div>
        <div><img src="@/img/pc/Frame@2x(10).png" alt=""><span>等级排名</span></div>
        <div><img src="@/img/pc/Frame@2x(11).png" alt=""><span>群发好友</span></div>
        <div><img src="@/img/pc/Frame@2x(12).png" alt=""><span>群管家设置</span></div>
        <div><img src="@/img/pc/Frame@2x(13).png" alt=""><span>安全学堂</span></div>
        <div><img src="@/img/pc/Frame@2x (1).png" alt=""><span>群聊盖楼</span></div>
        <div><img src="@/img/pc/Frame@2x (2).png" alt=""><span>一键删除好友</span></div>
      </div>
      <div>
        <div @click="downApp(1)">
          <p>下载安装 版本1</p>
        </div>
        <div @click="downApp(2)">
          <p>下载安装 版本2</p>
        </div>
      </div>
      <p>当前版本：{{versionNumber}} &nbsp {{appSize}}MB 更新于：{{time}}</p>
      <p>如下载的版本1无法安装，请下载安装版本2</p>
      <img src="@/img/pc/Slice 11@2x.png" alt="">
    </div>

    <div id='mobile'>

      <div>
        <img src="@/img/mobile/logo@2x (1).png" alt="">
        <img src="@/img/mobile/guanfang@2x.png" alt="">
      </div>
      <p>海鸥</p>
      <p>海鸥聊天 全方位守护你的隐私安全 已超 <span style="color: #4371FF;font-size: 25px;">5000000+</span> 用户正在使用</p>
      <div>
        <div><img src="@/img/pc/Frame@2x(15).png" alt=""><span>应用锁保护</span></div>
        <div><img src="@/img/pc/Frame@2x(14).png" alt=""><span>高清通话</span></div>
        <div><img src="@/img/pc/Frame@2x(10).png" alt=""><span>等级排名</span></div>
        <div><img src="@/img/pc/Frame@2x(11).png" alt=""><span>群发好友</span></div>
        <div><img src="@/img/pc/Frame@2x(12).png" alt=""><span>群管家设置</span></div>
        <div><img src="@/img/pc/Frame@2x(13).png" alt=""><span>安全学堂</span></div>
        <div><img src="@/img/pc/Frame@2x (1).png" alt=""><span>群聊盖楼</span></div>
        <div><img src="@/img/pc/Frame@2x (2).png" alt=""><span>一键删除好友</span></div>
      </div>
      <div>
        <div @click="downApp(1)">
          <p>下载安装 版本1</p>
        </div>
        <div @click="downApp(2)">
          <p>下载安装 版本2</p>
        </div>
      </div>
      <p>当前版本：{{versionNumber}} &nbsp {{appSize}}MB 更新于：{{time}}</p>
      <p>如下载的版本1无法安装，请下载安装版本2</p>

    </div>

  </div>

</template>
<script type="text/javascript" charset="UTF-8" src="https://cdn.xinstall.com/xinstall.js"></script>
<script>
import api from "@/api/api";
import request from '@/api/request';
import Base64 from 'base-64';
import {
  Notify
} from 'vant';
import {
  Dialog
} from 'vant';
export default {
  components: {

  },
  props: {
    menuIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {

      menuUrl: require('@/img/mobile/Frame@2x(2).png'),
      appSize: undefined,
      createTime: undefined,
      versionNumber: undefined,
      type: undefined,
      time: undefined,
      xInstall: null

    }
  },
  created() {
    this.getVersion(0)

    var xInstallData = XInstall.parseUrlParams();
    console.log(xInstallData)
    if (xInstallData && Object.keys(xInstallData).length > 0) {
      localStorage.setItem('xInstallData', JSON.stringify(xInstallData))
    } else {
      xInstallData = JSON.parse(localStorage.getItem('xInstallData'))
    }


    if (xInstallData) {
      let data = {
        account: xInstallData.account,
        XinShareId: xInstallData.XinShareId,
      }
      this.xInstall = new XInstall({
        appKey: "hnzdq5i",
        buttonId: [{
          idName: 'Button1',
          params: {
            account: xInstallData.account,
            XinShareId: xInstallData.XinShareId
          }
        },],
        /*xinstall初始化完成的回调函数*/
        onready: function () {

        }
      }, data);
    }


  },
  computed: {

  },
  mounted() {


  },

  destroyed() {

  },
  methods: {
    downApp(type) {


      if (type == 1) {
        this.toDown(api.apiConfig.androidOne)
        //window.location.href = api.apiConfig.androidOneUrl
      }
      if (type == 2) {
        this.toDown(api.apiConfig.androidTwo)
        //window.location.href = api.apiConfig.androidTwoUrl
      }


      // if (this.xInstall) {
      //   console.log('走第三方下载')
      //   this.xInstall.wakeupOrInstall();
      // } else {

      //   if (type == 1) {
      //     this.toDown(api.apiConfig.androidOne)
      //     //window.location.href = api.apiConfig.androidOneUrl
      //   }
      //   if (type == 2) {
      //     this.toDown(api.apiConfig.androidTwo)
      //     //window.location.href = api.apiConfig.androidTwoUrl
      //   }

      // }


    },
    toDown(type) {
      var that = this;
      request.postWay(
        api.apiConfig.authUrl, {
        file_path: that.encodeToBase64(type)
      },
        function (response) {
          console.log(that.decodeFromBase64(response.auth_url))
          window.location.href = that.decodeFromBase64(response.auth_url)

        }
      );
    },
    encodeToBase64(str) {
      return Base64.encode(str);
    },

    decodeFromBase64(base64Str) {
      return Base64.decode(base64Str);
    },
    getVersion(type) {
      var that = this;
      request.getWay(
        'https://api.haiouchat.com/api/app/edition', {
        type: type
      },
        function (response) {
          that.appSize = response.data.appSize;
          that.createTime = response.data.createTime;
          that.versionNumber = response.data.versionNumber;
          that.type = response.data.type;
          that.time = that.timestampToTime(that.createTime / 1000)

        }
      );





    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() + ':' : date.getSeconds() + '';
      return Y + M + D + h + m + s;
    }

  }
}

</script>

//pc端
<style scoped>
/* 当屏幕宽度大于或等于768像素时，改为浮动布局 */
@media (min-width: 768px) {
  #mobile {
    display: none;
  }

  #pc {
    display: flex;
    flex-flow: column;
    align-items: center;
  }

  #pc > img:nth-child(1) {
    width: 435px;
    height: 564px;
    position: absolute;
    left: 0;
    top: 0;
  }

  #pc > div:nth-child(2) {
    width: 298px;
    height: 298px;

    /* 灰色虚线边框 */
    border-radius: 0px 0px 0px 0px;
    margin-top: 134px;
    position: relative;
  }

  #pc > div:nth-child(2) > img:first-child {
    width: 298px;
    height: 298px;
    position: absolute;
    top: 0;
    left: 0;
  }

  #pc > div:nth-child(2) > img:last-child {
    width: 106px;
    height: 106px;
    position: absolute;
    right: 12px;
    bottom: 16px;
  }

  #pc > p:nth-child(3) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    line-height: 50px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 32px;
    margin-bottom: 0;
  }

  #pc > div:nth-child(4) {
    display: flex;
    flex-flow: row;
    align-items: center;
    margin-top: 50px;
  }

  #pc > div:nth-child(4) > div {
    display: flex;
    flex-flow: column;
    align-items: center;
    margin-right: 38px;
  }

  #pc > div:nth-child(4) > div > img {
    width: 48px;
    height: 48px;
  }

  #pc > div:nth-child(4) > div > span {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    text-align: center;
    font-style: normal;
    text-transform: none;

    margin-top: 12px;
    margin-bottom: 0;
  }

  #pc > div:nth-child(5) {
    display: flex;
    flex-flow: row;
    align-items: center;
    margin-right: 38px;
    margin-top: 80px;
  }

  #pc > div:nth-child(5) > div {
    width: 310px;
    height: 52px;
    box-shadow: 0px 4px 12px 0px rgba(67, 113, 255, 0.3);
    border-radius: 44px 44px 44px 44px;
    border: 1px solid #4371ff;

    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #4371ff;
    line-height: 19px;
    text-align: center;
    font-style: normal;
    text-transform: none;

    margin-right: 28px;
    margin-left: 28px;
  }

  #pc > div:nth-child(5) > div:hover {
    background: #4371ff;

    color: #ffffff;
  }

  #pc > p:nth-child(6) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 50px;
    margin-bottom: 0;
  }

  #pc > p:nth-child(7) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 20px;
    margin-bottom: 0px;
  }

  #pc > img:nth-child(8) {
    width: 248px;
    height: 370px;
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
</style>

//移动端
<style scoped>
/* 当屏幕宽度小于或等于768像素时，应用以下样式 */
@media (max-width: 768px) {
  #pc {
    display: none;
  }

  #mobile {
    display: flex;
    flex-flow: column;
    align-items: center;
  }

  #mobile > div:nth-child(1) {
    width: 72px;
    height: 72px;
    background: #ffffff;
    border-radius: 0px 0px 0px 0px;

    /* 灰色虚线边框 */
    margin-top: 40px;
    position: relative;
  }

  #mobile > div:nth-child(1) > img:first-child {
    width: 72px;
    height: 72px;
    position: absolute;
    top: 0;
    left: 0;
  }

  #mobile > div:nth-child(1) > img:last-child {
    width: 28px;
    height: 16px;
    position: absolute;
    top: -9px;
    right: -10px;
  }

  #mobile > p:nth-child(2) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    line-height: 19px;
    letter-spacing: 2px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 8px;
    margin-bottom: 0;
  }

  #mobile > p:nth-child(3) {
    width: 250px;

    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 30px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 24px;
    margin-bottom: 0;
  }

  #mobile > div:nth-child(4) {
    display: flex;
    flex-flow: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    margin-top: 31px;
    margin-left: 7px;
  }

  #mobile > div:nth-child(4) > div {
    width: 72px;
    height: 64px;
    display: flex;
    flex-flow: column;
    align-items: center;
    margin-bottom: 24px;
    margin-right: 5px;
    margin-left: 5px;
  }

  #mobile > div:nth-child(4) > div > img {
    width: 40px;

    height: 40px;
  }

  #mobile > div:nth-child(4) > div > span {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 16px;
    text-align: center;
    font-style: normal;
    text-transform: none;

    margin-top: 8px;
    margin-bottom: 0;
  }

  #mobile > div:nth-child(5) {
    display: flex;
    flex-flow: column;
    align-items: center;
    margin-top: 37px;
  }

  #mobile > div:nth-child(5) > div {
    width: 311px;
    height: 44px;
    box-shadow: 0px 4px 12px 0px rgba(67, 113, 255, 0.3);
    border-radius: 44px 44px 44px 44px;
    border: 1px solid #4371ff;

    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #4371ff;
    line-height: 16px;
    text-align: center;
    font-style: normal;
    text-transform: none;

    margin-bottom: 15px;
  }

  #mobile > div:nth-child(5) > div:hover {
    background: #4371ff;

    color: #ffffff;
  }

  #mobile > p:nth-child(6) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 14px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 9px;
    margin-bottom: 0;
  }

  #mobile > p:nth-child(7) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 14px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 12px;
    margin-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/toDown/index.vue